import React from 'react';
import styled, { css } from 'styled-components';
import tw from 'twin.macro';
import { Button, Copy, Heading } from 'components/components/atoms';
import { Container } from 'components/shared';
import trackAnalyticsEvent from 'utils/trackAnalyticsEvent';

const boxShadow = css`
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.2);
`;

const PromotionCard = styled.div`
  ${boxShadow}

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns:
      minmax(0, 1fr) minmax(0, 1.25fr) minmax(0, 2.5fr)
      minmax(7.5rem, 0.85fr);
    column-gap: 1.5rem;
  }
`;

const Logo = styled.img`
  width: 10.5rem;

  @media (min-width: 768px) {
    width: 11.25rem;
  }
`;

const AprLabel = styled.span`
  font-size: 0.625rem;
  letter-spacing: 0.03rem;
`;

const StyledButton = styled(Button)`
  ${tw`h-auto px-5 py-3 md:w-auto`}

  & > div {
    min-width: 4.875rem;
  }
`;

const TitlePromotionCTA = ({ promotion = {} }) => {
  const cta = promotion && promotion.cta ? promotion.cta : {};
  const handlePromotionClick = () => {
    trackAnalyticsEvent({
      gtagEvent: 'FeaturedPromoClick',
      mouseflowTag: 'FeaturedPromoClick',
    });
  };

  return (
    <section className='w-screen py-6 md:py-10'>
      <Container>
        <PromotionCard className='flex flex-col items-center rounded-lg bg-white px-5 py-8 text-mattamy-blue md:items-center md:px-10 md:py-8'>
          <Logo
            src={promotion.logo}
            alt={promotion.logoAlt}
            className='mb-4 md:mb-0 p-1'
          />

          <div className='text-center md:text-left'>
            <Heading as='h2' color='blue'>
              {promotion.title}
            </Heading>
            <AprLabel className='font-bold uppercase text-action-blue'>
              {promotion.rateLabel}
            </AprLabel>
          </div>

          <div className='my-5 text-center md:my-0 md:text-left'>
            <Heading as='h3' color='blue'>
              {promotion.heading}
            </Heading>
            <Copy className='mb-0 max-w-md' color='black'>
              {promotion.description}
            </Copy>
          </div>

          <div className='w-full md:w-full text-right'>
            {cta.text && cta.href && (
              <StyledButton
                href={cta.href}
                target={cta.target}
                color='action-blue'
                textColor='white'
                variant='filled'
                buttonDescription={cta.text}
                linkWrapperDescription={cta.text}
                fullWidthMobile
                onClick={handlePromotionClick}
              >
                {cta.text}
              </StyledButton>
            )}
          </div>
        </PromotionCard>
      </Container>
    </section>
  );
};

export default TitlePromotionCTA;
